import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('../auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'beneficiaries',
    loadChildren: () => import('../beneficiaries/beneficiaries.module').then((m) => m.BeneficiariesModule),
    canActivate: [AuthGuard],
    data: { groups: ['ADMIN', 'STRUCTURE', 'RECEPTION', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE'] },
  },
  {
    path: 'agenda',
    loadChildren: () => import('../agenda/agenda.module').then((m) => m.AgendaModule),
    canActivate: [AuthGuard],
    data: { groups: ['ADMIN', 'STRUCTURE', 'DIRECTION', 'DIRECTION+'] },
  },
  {
    path: 'community-action',
    loadChildren: () => import('../community-action/community-action.module').then((m) => m.CommunityActionModule),
    canActivate: [AuthGuard],
    data: { groups: ['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE'] },
  },
  {
    path: 'queries',
    loadChildren: () => import('../queries/queries.module').then((m) => m.QueriesModule),
    canActivate: [AuthGuard],
    data: { groups: ['ADMIN', 'STRUCTURE', 'RECEPTION', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE'] },
  },
  {
    path: 'admin',
    loadChildren: () => import('../admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard],
    data: { groups: ['ADMIN'] },
  },
  {
    path: 'external-links',
    loadChildren: () => import('../external-links/external-links.module').then((m) => m.ExternalLinksModule),
    pathMatch: 'full',
  },
  {
    path: 'inbox',
    loadChildren: () => import('../inbox/inbox.module').then((m) => m.InboxModule),
    canActivate: [AuthGuard],
    data: { groups: ['STRUCTURE', 'DIRECTION+', 'TERRITORY'] },
  },
  {
    path: 'tutorials',
    loadChildren: () => import('../tutorials/tutorials.module').then((m) => m.TutorialsModule),
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'downloads',
    loadChildren: () => import('../downloads/downloads.module').then((m) => m.DownloadsModule),
    canActivate: [AuthGuard],
    data: { groups: ['ADMIN', 'DIRECTION+'] },
  },
  {
    path: '**',
    loadChildren: () => import('../errors/errors.module').then((m) => m.ErrorsModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
